<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>创建会员</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <div style="width: 100%;height: 30px;display: flex; justify-content:space-between">
        <div>
          <label style="color: #FA5858">*</label>
          <span style="width: 15%">会员姓名： </span>
          <el-input style="width: 300px" v-model="customer.customerName" size="mini" />
        </div>
        <div>
          <label style="color: #FA5858">*</label>
          <span>手机：</span>
          <el-input style="width: 300px" @change="checkCustomerPhone" v-model="customer.phone" size="mini"
                    onkeyup="value=value.replace(/[^\d]/g,'')"/>
        </div>
      </div>
      <div style="width: 100%; height: 30px;margin-top:15px;display: flex; align-items: center; justify-content:space-between">
        <div>
          <label style="color: #ffffff">*</label>
          <span >刀具号码：</span>
          <el-input style="width: 300px" @change="checkCustomerKnife" v-model="customer.knife" size="mini" />
        </div>
        <div>
          <label style="color: #FA5858">*</label>
          <span >生日：</span>
          <el-date-picker size="mini" style="width: 300px"
                          v-model="customer.birthday"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 10px">
      <div style="width: 100%;display: flex; justify-content:space-between">
        <div>
          <label style="color: #FA5858">*</label>
          <span>性别： </span>
          <el-radio-group style="margin-left: 20px" v-model="customer.gender" @change="changeCustomerGender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="width: 100%;margin-top:15px;display: flex;align-items: center">
        <label style="color: #FA5858">*</label>
        <span>会员来源：</span>
        <el-radio-group style="width: 90%" size="mini" v-model="customer.source">
          <el-radio :label="1">附近居民</el-radio>
          <el-radio :label="2">附近工作</el-radio>
          <el-radio :label="3">偶遇</el-radio>
          <el-radio :label="4">附近办事</el-radio>
          <el-radio :label="5">朋友介绍</el-radio>
          <el-radio :label="6">广告</el-radio>
          <el-radio :label="7">活动卡</el-radio>
          <el-radio :label="8">其他</el-radio>
        </el-radio-group>
      </div>
      <div style="width: 100%;margin-top:15px;display: flex;align-items: center">
        <label style="color: #FA5858">*</label>
        <span >会员职业：</span>
        <el-radio-group style="width: 90%" size="mini" v-model="customer.profession">
          <el-radio :label="1">企业</el-radio>
          <el-radio :label="2">事业单位</el-radio>
          <el-radio :label="3">政府</el-radio>
          <el-radio :label="4">学生</el-radio>
          <el-radio :label="5">无业</el-radio>
          <el-radio :label="6">退休</el-radio>
        </el-radio-group>
      </div>
    </el-card>
    <!-- <el-card class="box-card" style="margin-top: 10px">
      <div style="width: 100%;display: flex">
        <span >足部筛查：</span>
        <el-checkbox-group style="width: 90%" size="mini" v-model="customer.feet">
          <el-checkbox :label="1">脚气</el-checkbox>
          <el-checkbox :label="2">手气</el-checkbox>
          <el-checkbox :label="3">灰指甲</el-checkbox>
          <el-checkbox :label="4">甲沟炎</el-checkbox>
          <el-checkbox :label="5">跖疣</el-checkbox>
          <el-checkbox :label="6">鸡眼</el-checkbox>
          <el-checkbox :label="7">脚垫</el-checkbox>
          <el-checkbox :label="8">干裂</el-checkbox>
          <el-checkbox :label="9">正常</el-checkbox>
          <el-checkbox :label="10">拇外翻</el-checkbox>
          <el-checkbox :label="11">高弓足</el-checkbox>
          <el-checkbox :label="12">扁平足</el-checkbox>
          <el-checkbox :label="13">湿疹</el-checkbox>
          <el-checkbox :label="14">嵌甲</el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="width: 100%;margin-top:25px;display: flex">
        <span >既往病史：</span>
        <el-checkbox-group style="width: 90%" size="mini" v-model="customer.pasts">
          <el-checkbox :label="1">糖尿病</el-checkbox>
          <el-checkbox :label="2">高血压</el-checkbox>
          <el-checkbox :label="3">低血糖</el-checkbox>
          <el-checkbox :label="4">心脏病</el-checkbox>
          <el-checkbox :label="5">过敏</el-checkbox>
          <el-checkbox :label="6">晕刀</el-checkbox>
          <el-checkbox :label="7">晕血</el-checkbox>
        </el-checkbox-group>
      </div>
    </el-card> -->


    <span class="dialog-footer">
        <el-button size="mini" @click="closeCustomerDialog">取 消</el-button>
        <el-button size="mini" @click="createCustomer">确 定</el-button>
      </span>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId : window.sessionStorage.getItem('currentOrgId'),
      userId : window.sessionStorage.getItem("userId"),
      userName : window.sessionStorage.getItem("userName"),
      customer:{
        id:'',
        customerName:'',
        gender:'',
        phone:'',
        birthday:'',
        age:'',
        systemFileNo:'',
        pageFileNo:'',
        knife:'',
        source:'',
        profession:'',
        customerType:'',
        feet:[],
        pasts:[],
        childCustomers:'',
        creator:'',
        level:'',
        registerOrgId:'',
        operateType:'',
        relevanceCustomers:[],
        productDiscount:'',
        balance:'',
        giveBalance:'',
        totalBalance:'',
        openId:''
      },
    }
  },
  methods:{
    async checkCustomerPhone(){
      const {data:res} = await this.$http.get(`/customer/check/phone/${this.customer.phone}`);
      if (res.data > 0){
        this.phoneExist = true;
        this.$message.warning("该手机号已经存在！")
      } else {
        this.phoneExist = false;
      }
    },
    async checkCustomerKnife(){
      const {data:res} = await this.$http.get(`/customer/check/knife/${this.customer.knife}/orgId/${this.currentOrgId}`);
      if (res.data > 0){
        this.knifeExist = true;
        this.$message.warning("该刀具号已经存在！")
      } else {
        this.knifeExist = false;
      }
    },
    changeCustomerGender(value){
      this.customer.gender = value;
    },
    //创建会员
    async createCustomer(){
      if (this.customer.customerName === ''){
        return this.$message.warning("请填写会员姓名！");
      }
      if (this.customer.phone === ''){
        return this.$message.warning("请填写手机！");
      }
      if (this.customer.birthday === ''){
        return this.$message.warning("请填写生日！");
      }
      if (this.customer.gender === ''){
        return this.$message.warning("请填写性别！");
      }
      if (this.customer.source === ''){
        return this.$message.warning("请填写来源！");
      }
      if (this.customer.profession === ''){
        return this.$message.warning("请填写职业！");
      }
      if (this.phoneExist){
        return this.$message.warning("该手机号已经存在！");
      }
      if (this.knifeExist){
        return this.$message.warning("该刀具号已经存在！");
      }

      this.customer.operateType = 1;
      this.customer.creator = this.userId;
      this.customer.level = 0;
      this.customer.registerOrgId = this.currentOrgId;
      this.customer.childCustomers = this.multipleSelection;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/customer/createCustomer`, this.customer)
      if (res.code !== 200){
        this.$message.error("创建会员失败！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      if (res.code === 200){
        this.$message.success("创建会员成功！")
        let customerId = res.data;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        await this.$router.push({path: '/card', query: {id:customerId}});
      }
    },
    closeCustomerDialog(){
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped lang="less">
.container {
  height: 90vh;
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/NewMember.vue